<template>
  <div>
    <div class="text-h4">
      Split Factory Item
    </div>
    <v-progress-linear :indeterminate="true" v-if="isLoading"></v-progress-linear>
    <v-simple-table v-else>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Goods
            </th>
            <th class="text-left">
              Size Range
            </th>
            <th class="text-left">
              Received Mass
            </th>
            <th class="text-left">
              Processing Mass
            </th>
            <th class="text-left">
              Harvested Mass
            </th>
            <th class="text-left">
              # of animals
            </th>
            <th class="text-left">
              Percentage Split
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>Original:</b></td>
            <td>{{ stockItem.sizeMin }} - {{ stockItem.sizeMax }} </td>
            <td>{{ stockItem.receivedMass }}</td>
            <td>{{ stockItem.processingMass }}</td>
            <td>{{ stockItem.harvestedMass }}</td>
            <td>{{ stockItem.quantity }}</td>
            <td>
              <v-btn
                data-cy="SplitFactoryItem-button-new"
                color="success"
                @click="addNewItem()"
              >
                Split
              </v-btn>
            </td>
          </tr>
          <tr v-for="(newItem, index) in newItems" :key="`newItem-${index}`">
            <td>
              <v-combobox
                :items="listStockTypes"
                v-model="newItem.stockType"
              />
            </td>
            <td>{{ newItem.sizeMin }} - {{ newItem.sizeMax}}</td>
            <td>
              <v-text-field
                v-model="newItem.receivedMass"
                :data-cy="`SplitFactoryItem-receivedMass-${index}`"
                @input="receivedMassChanged(newItem)"
                type="Number"
              ></v-text-field>
              <!-- <split-value-adjuster
                :mass="stockItem.receivedMass"
                :percentage="newItem.splitPercentage"
                @change="massChanged($event, stockItem, 'receivedMass')"
              /> -->
            </td>
            <td>
              <v-text-field
                v-model="newItem.processingMass"
                :data-cy="`receivedMass-processingMass-${index}`"
                @input="processingMassChanged(newItem)"
              ></v-text-field>
              <!-- <split-value-adjuster
                :mass="stockItem.processingMass"
                :percentage="newItem.splitPercentage"
                @change="massChanged($event, stockItem, 'processingMass')"
              /> -->
            </td>
            <td>
              <v-text-field
                v-model="newItem.harvestedMass"
                :data-cy="`receivedMass-harvestedMass-${index}`"
                @input="harvestedMassChanged(newItem)"
              ></v-text-field>
              <!-- <split-value-adjuster
                :mass="stockItem.harvestedMass"
                :percentage="newItem.splitPercentage"
                @change="massChanged($event, stockItem, 'harvestedMass')"
              /> -->
            </td>
            <td>
              {{ getPercentageValue(stockItem.quantity, newItem.splitPercentage) }}
              </td>
            <td>
              <v-text-field
                v-model="newItem.splitPercentage"
                :data-cy="`splitPercentage-${index}`"
                @input="splitPercentageChanged(newItem)"
              ></v-text-field>
            </td>
          </tr>
        </tbody>
      </template>
  </v-simple-table>
  <v-btn
    v-if="!isLoading"
    data-cy="SplitFactoryItem-button-save"
    color="success"
    @click="accept">Accept</v-btn>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import formatting from '../mixins/formatting';
import SplitValueAdjuster from '../components/SplitValueAdjuster.vue';

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { SplitValueAdjuster },
  name: 'SplitFactoryItem',
  module: 'FactoryItem',
  mixins: [formatting, loading],
  data() {
    return {
      /**
      /**
       * Query Id for CanningProcess
       */
      stockItemId: this.$route?.query.stockItemId,
      existingItemPercentage: 100,
      newItemPercentage: 0,
      newItems: [],
    };
  },
  computed: {
    ...mapState('stockItems', ['stockItem']),
    ...mapState('stockTypes', ['stockTypes']),
    listStockTypes() {
      return this.stockTypes.map((s) => s.name);
    },
    existingItem() {
      const { stockItem } = this;
      return {
        stockType: stockItem.stockType,
        sizeMin: stockItem.sizeMin,
        sizeMax: stockItem.sizeMax,
        receivedMass: stockItem.receivedMass * (this.existingItemPercentage / 100),
        packedMass: stockItem.packedMass * (this.existingItemPercentage / 100),
        harvestedMass: stockItem.harvestedMass * (this.existingItemPercentage / 100),
        quantity: Math.round(stockItem.quantity * (this.existingItemPercentage / 100)),
      };
    },
  },
  // watch: {
  //   existingItemPercentage() {
  //     this.calculatePercentageSplit();
  //   },
  //   newItems: {
  //     immediate: true,
  //     deep: true,
  //     handler() {
  //       this.calculatePercentageSplit();
  //     },
  //   },
  // },
  async mounted() {
    this.isLoading = true;
    await Promise.all([
      (async () => {
        await this.LOAD_stockItem(this.stockItemId);
      })(),
      (async () => {
        this.newItems = await this.LOAD_stockItemChildren(this.stockItemId);
      })(),
      (async () => {
        await this.LOAD_stockTypes();
      })(),
    ]);
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('stockItems', ['LOAD_stockItem', 'SPLIT_stockItems', 'LOAD_stockItemChildren']),
    ...mapActions('stockTypes', ['LOAD_stockTypes']),
    async accept() {
      this.isLoading = true;
      const { newItems, stockItem } = this;
      await this.SPLIT_stockItems({
        stockItem: {
          id: stockItem.id,
        },
        stockItems: newItems,
      });
      this.isLoading = false;
      this.$router.push({
        name: 'processing-ListFactoryItem',
      });
    },
    addNewItem() {
      const { stockItem } = this;
      this.newItems.push({
        stockType: stockItem.stockType,
        sizeMin: stockItem.sizeMin,
        sizeMax: stockItem.sizeMax,
        deliveryNoteId: stockItem.deliveryNoteId,
        receivedMass: 0,
        packedMass: 0,
        harvestedMass: 0,
        processingMass: 0,
        quantity: 0,
        splitPercentage: 0,
      });
    },
    calculatePercentageSplit() {
      const newItemPercentages = this.newItems.map((n) => n.splitPercentage);
      if (newItemPercentages.length === 0) {
        return;
      }
      const totalNewItemPercentages = newItemPercentages.reduce((c, p) => Number(c) + Number(p));
      // if (this.existingItemPercentage > 100) {
      //   this.existingItemPercentage = 100;
      // }
      this.existingItemPercentage = 100 - totalNewItemPercentages;
    },
    getPercentageValue(val, percentage) {
      return this.getPercentageVal(val, percentage).toFixed(3);
    },
    getPercentageVal(val, percentage) {
      return (val * (percentage / 100));
    },
    receivedMassChanged(item) {
      this.processMassChange(item, 'receivedMass');
      console.log(item);
    },
    processMassChange(item, prop) {
      const { newItems, stockItem } = this;
      const divider = (newItems.length - 1);
      const newMass = parseFloat(item[prop]) / divider;
      const newItemIndex = newItems.indexOf(item);
      if (prop !== 'splitPercentage') {
        const splitPercentage = (newMass / parseFloat(stockItem[prop])) * 100;
        // this.newItems[newItemIndex][prop].splitPercentage = splitPercentage;
        const percentage = (100 - splitPercentage) / divider;
        this.newItems[newItemIndex].splitPercentage = (100 - percentage).toFixed(3);
        newItems.forEach((newItem, i) => {
          if (newItemIndex !== i) {
            this.newItems[i][prop] = (stockItem[prop] - newMass).toFixed(3);
            this.newItems[i].splitPercentage = percentage;
          }
        });
      } else {
        // percentage change
        // eslint-disable-next-line max-len
        this.newItems[newItemIndex].receivedMass = (stockItem.receivedMass * (item.splitPercentage / 100)).toFixed(3);
        this.processMassChange(item, 'receivedMass');
        // eslint-disable-next-line max-len
        this.newItems[newItemIndex].harvestedMass = (stockItem.harvestedMass * (item.splitPercentage / 100)).toFixed(3);
        this.processMassChange(item, 'harvestedMass');
        // eslint-disable-next-line max-len
        // this.newItems[newItemIndex].processMass = (stockItem.processMass * (item.splitPercentage / 100)).toFixed(3);
        // this.processMassChange(item, 'processMass');
      }
    },
    processingMassChanged(item) {
      this.processMassChange(item, 'processMass');
      console.log(item);
    },
    harvestedMassChanged(item) {
      this.processMassChange(item, 'harvestedMass');
      console.log(item);
    },
    splitPercentageChanged(item) {
      this.processMassChange(item, 'splitPercentage');
      console.log(item);
    },
  },
};
</script>
